import { AbstractPageTemplate } from 'foundations-components/transitional/components/AbstractPageTemplate';
import { jsx as _jsx } from "react/jsx-runtime";
const PersistentFullScreenWrapper = ({
  children
}) => /*#__PURE__*/_jsx(AbstractPageTemplate, {
  "data-test-id": "full-page-loading-hide-nav",
  children: children
});
export default PersistentFullScreenWrapper;